import skillsMethods from './Skills'

export const SkillsServices = {
  ...skillsMethods
}

export * from './Skills.types'
